import { z } from 'zod';

export const shopSchema = z.object({
  name: z
    .string()
    .min(1, 'validation.required')
    .min(3, 'validation.minLength')
    .max(100, 'validation.maxLength'),
  description: z
    .string()
    .max(2000, 'validation.maxLength')
    .optional(),
  address: z
    .string()
    .max(500, 'validation.maxLength')
    .optional(),
  city: z
    .string()
    .max(100, 'validation.maxLength')
    .optional(),
  country: z
    .string()
    .max(100, 'validation.maxLength')
    .optional(),
  phone: z
    .string()
    .regex(/^\+?[0-9]{8,15}$/, 'validation.invalidPhone')
    .optional()
    .or(z.literal('')),
  email: z
    .string()
    .email('validation.email')
    .optional()
    .or(z.literal('')),
  logo: z
    .string()
    .url('validation.invalidUrl')
    .optional()
    .or(z.literal('')),
  banner: z
    .string()
    .url('validation.invalidUrl')
    .optional()
    .or(z.literal('')),
  isActive: z
    .boolean()
    .default(true),
});

export type ShopFormData = z.infer<typeof shopSchema>;
